/* eslint-disable*/
import SurveyTestForm from '../prediabetedTestForm';
import './styles.scss';
import PropTypes from 'prop-types';
import { useContext, useEffect, useState } from 'react';
import GlobalContext from 'contexts';
import useFetchData from 'hooks/useFetchData';
import ExcelDownload from 'components/ExcelDownload';
import RedFlags from './redFlags';
import PrediabetesTestForm from '../prediabetedTestForm';
import { Switch } from '@mui/material';

export function PrediabetesSummery({ clientProductId, clientProductUuid, handleChangeMode }) {
  const { globalProductInfo, currentCustomer } = useContext(GlobalContext);
  const [positiveQuestions, setPositiveQuestions] = useState(null);
  const questionPS = globalProductInfo.find(
    (pi) => pi?.productStage?.type === 'שאלון'
  )?.id;
  let { data: questionsData } = useFetchData(
    'client-prediabetes-measures/getDoctorSummeryAndClientAnswers',
    questionPS
  );
  const [questions, setQuestions] = useState([]);
  let { data: surveySummeryHTML } = useFetchData(
    'client-prediabetes-measures/getSummeryHTML',
    clientProductUuid
  );
  const [summeryData, setSummeryDate] = useState();

  useEffect(() => {
    if (surveySummeryHTML) setSummeryDate(surveySummeryHTML);
  }, [surveySummeryHTML]);

  useEffect(() => {
    if (questionsData?.questions?.length) {
      let obj = {};
      let questionsArr = [];
      obj.question = 'שם הלקוח';
      obj.answer = `${currentCustomer.first_name} ${currentCustomer.last_name}`;
      questionsArr.push(obj);
      obj = {};
      obj.question = 'ת.ז';
      obj.answer = `${currentCustomer.ssn}`;
      questionsArr.push(obj);
      questionsData.questions.forEach((q) => {
        if (q.answer !== '') {
          obj = {};
          obj.question = q?.question?.text;
          obj.category = q?.question?.categoryName;
          obj.answer = q.answer;
          questionsArr.push(obj);
        }
      });

      setPositiveQuestions(questionsData.summery);
      setQuestions(questionsArr);
    }
  }, [questionsData?.questions, questionsData?.summery]);
  const [isDoctorMeeting, setIsDoctorMeeting] = useState(false);
  return (
    <>
      {summeryData && (
        <div>
          <div
            dangerouslySetInnerHTML={{
              __html: summeryData
            }}
          ></div>
          <RedFlags></RedFlags>
          <div className="wrapper-actions-doctor">
            <div>
              <label>המלצה לפגישה עם רופא</label>
              <Switch
                checked={isDoctorMeeting}
                onChange={() => setIsDoctorMeeting(!isDoctorMeeting)}
              />
            </div>
            <div className="wrapper-questions">
              {questions && (
                <ExcelDownload
                  data={questions}
                  filename={'questions'}
                  txtLink={'הורדת השאלון'}
                ></ExcelDownload>
              )}
            </div>
          </div>
          <PrediabetesTestForm
            clientProductId={clientProductId}
            clientProductUuid={clientProductUuid}
            handleChangeMode={handleChangeMode}
            isSummery={true}
            positiveQuestions={positiveQuestions}
            isDoctorMeeting={isDoctorMeeting}
            doctorRecomends={questionsData?.recomends}
          ></PrediabetesTestForm>
        </div>
      )}
    </>
  );
}

PrediabetesSummery.propTypes = {
  clientProductId: PropTypes.string,
  clientProductUuid: PropTypes.string,
  handleChangeMode: PropTypes.func
};
